import { Smartphone } from 'lucide-react';
import React from 'react';

interface LoaderProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  scale?: '0.25x' | '0.5x' | '0.75x' | '1x' | '1.25x' | '1.5x' | '1.75x' | '2x';
  fullScreen?: boolean;
  className?: string;
  title?: string;
  subtitle?: string;
  progress?: number;
  showProgress?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  size = 'lg',
  scale = '1x',
  fullScreen = false,
  className = '',
  title = '~Loading~',
  subtitle = 'Please wait while we prepare your trading experience',
  progress = 0,
  showProgress = false,
}) => {
  const sizeClasses = {
    xs: 'h-12 w-12',
    sm: 'h-16 w-16',
    md: 'h-24 w-24',
    lg: 'h-32 w-32',
    xl: 'h-40 w-40',
  };

  const scaleClasses = {
    '0.25x': 'scale-[0.25]',
    '0.5x': 'scale-50',
    '0.75x': 'scale-75',
    '1x': 'scale-100',
    '1.25x': 'scale-125',
    '1.5x': 'scale-150',
    '1.75x': 'scale-[1.75]',
    '2x': 'scale-[2]',
  };


  const LoaderContent = () => (
    <div className={`loader-container ${className} ${scaleClasses[scale]}`}>
      <div className={`loader-wrapper ${sizeClasses['sm']}`}>
        {/* Spinner Animation */}
        <div className="spinnerwrap">
          <div className="outerCircle"></div>
          <div className="innerCircle"></div>
          <div className="icon"></div>
          <div id="diamond-shield"></div>
        </div>
        
        {/* Logo Symbol */}
        <img
          src="/images/logo_symbol.svg"
          alt="MIAI Symbol"
          className="loader-logo"
        />
      </div>
      
      {/* Loading Text */}
      <div className="loader-text">
        <div className="loader-title">{title}</div>
        <div className="loader-subtitle">{subtitle}</div>
        
        {/* Progress Bar */}
        {showProgress && (
          <div className="w-full max-w-xs mt-4">
            <div className="bg-gray-700 rounded-full h-2 overflow-hidden">
              <div 
                className="bg-[#2AB7A6] h-full transition-all duration-500 ease-out rounded-full"
                style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
              />
            </div>
            <div className="text-xs text-gray-400 mt-2 text-center">
              {Math.round(progress)}%
            </div>
          </div>
        )}
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loader-overlay">
        <LoaderContent />
      </div>
    );
  }

  return <LoaderContent />;
};

export default Loader;
